import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";
import { notificationAPI } from "./api";

export async function subscribeUserToPush(userId) {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            alert("Разрешение на уведомления не предоставлено");
            return null;
        }

        // Прямо передаём ключ строкой, без atob
        const currentToken = await getToken(messaging, {
            vapidKey: "BE4IvDKNpcyyo4IC4FXn6mzGlAnFcs2E6rvKp3Tz16NCzxBZ_GuJhjoQWrNvZw5jvoDB1YpOSzbYJRXSKwvLvOQ",
        });

        if (currentToken) {
            // console.log("Токен FCM получен:", currentToken);
            await notificationAPI.savePushToken(userId, currentToken);
            return currentToken;
        } else {
            alert("Не удалось активировать уведомления");
            return null;
        }
    } catch (err) {
        console.error("Ошибка подписки:", err);
        alert("Ошибка подписки на уведомления");
        return null;
    }
}

export async function unsubscribeUserFromPush() {
    // Можно добавить удаление токена
}
